import { Box, ListItemText, MenuItem, Stack } from "@mui/material"
import { checkPermission } from "library/authorization/index.mjs"
import { conditionalComponent } from "lib/@components/slot/conditional-component"
import { makeBusyFunction } from "lib/@components/busy/make-busy-function"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { filterSchedules } from "ioc"
import Iconify from "minimals-template/components/Iconify"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"
import { useSelectedItemIds } from "routes/schedule/lib/useSelectedItems"
import { ActionMenu } from "slot-definitions"
import { addSchedulesToReviewProject } from "../../controller/add-schedules-to-review-project"
import { showAddSchedulesResult } from "../../helpers/show-add-schedules-result"
import { useSelectReviewProject } from "../../components/select-review-project-dialog"
import { REVIEW_PROJECTS_AUTHORING_ADMIN_DEMANDS } from "../../server/constants.mjs"
import { FEATURE_FLAG_REVIEW_PROJECTS } from "../../server/feature-flag-review-projects.mjs"

ActionMenu.plug(conditionalComponent(canRenderAddSelectedToReviewProject, <AddSelectedToReviewProject />))

function AddSelectedToReviewProject() {
    const find = useTreeItemIndex()?.retrieve
    const chooseReviewProject = useSelectReviewProject()
    const schedules = useSelectedItemIds()
        .map((item) => find(item))
        .filter(Boolean)
    const selection = filterSchedules(schedules).map("_id")
    const saveSelectedSchedules = makeBusyFunction(persistSelectedSchedules, "Adding schedules to review project")

    if (!selection.length) return null

    return (
        <MenuItem onClick={handleAddSelectedSchedules}>
            <Stack direction="row" alignItems="center">
                <Box sx={{ lineHeight: 0 }} mr={1}>
                    <Iconify icon="mdi:file-document-plus-outline" />
                </Box>
                <ListItemText>
                    Add {selection.length} selected {"schedule".pluralize(selection.length)} to review project
                </ListItemText>
            </Stack>
        </MenuItem>
    )

    function handleAddSelectedSchedules() {
        chooseReviewProject().then(handleChosenProject).catch(handleChooseProjectError)
    }

    function handleChosenProject(project) {
        const projectId = project?.id || project?._id
        if (!projectId) return
        saveSelectedSchedules({ ...project, id: String(projectId) }).catch(handleChooseProjectError)
    }

    function handleChooseProjectError(error) {
        if (!error) return
        errorSnackbar(error?.message || "Unable to choose review project")
    }

    async function persistSelectedSchedules(project) {
        try {
            const result = await addSchedulesToReviewProject({ id: project.id, scheduleIds: selection.map(String) })
            showAddSchedulesResult(result)
        } catch (error) {
            errorSnackbar(error?.message || "Unable to add selected schedules")
        }
    }
}

function canRenderAddSelectedToReviewProject() {
    return (
        checkPermission(`$feature-${FEATURE_FLAG_REVIEW_PROJECTS}`) &&
        checkPermission(REVIEW_PROJECTS_AUTHORING_ADMIN_DEMANDS, false)
    )
}
